import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { ReactNode, PureComponent, createRef } from 'react';
import { OverlayProps, Overlay, Tooltip, Popover } from 'react-bootstrap';

export interface OverlayBoxProps
  extends Omit<OverlayProps, 'title' | 'children' | 'target'> {
  title: ReactNode;
  type?: 'tooltip' | 'popover';
  custom?: boolean;
}

@observer
export class OverlayBox extends PureComponent<OverlayBoxProps> {
  @observable
  show = false;

  target = createRef<HTMLDivElement>();

  render() {
    const { title, children, custom = false, type = 'popover', placement = 'left', ...props } = this.props,
      { show, target } = this;

    return (
      <>
        <div
          className="d-inline-block"
          ref={target}
          tabIndex={-1}
          onMouseEnter={type === 'tooltip' ? () => (this.show = !show) : undefined}
          onMouseLeave={type === 'tooltip' ? () => (this.show = false) : undefined}
          onFocus={type === 'popover' ? () => (this.show = !show) : undefined}
          onBlur={type === 'popover' ? () => (this.show = false) : undefined}
        >
          {children}
        </div>

        <Overlay
          {...props}
          placement={placement}
          target={target.current}
          show={show}
        >
          {type === 'tooltip' ? props => <Tooltip {...props}>{title}</Tooltip> : props => <Popover bsPrefix={custom ? 'custom-popover' : 'popover'} {...props}>{title}</Popover>}

        </Overlay>
      </>
    );
  }
}
